import { http } from "config/http";

export const getUsersData = async () => {
    try {
        const res: any = await http.get(`get_all_users_list?client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getUsersDataById = async (id: string) => {
    try {
        const res: any = await http.get(`get_user_by_id?user_id=${id}&client_env=${localStorage.getItem("clientName")}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const addUsersData = async (body: { firstName: string, lastName: string, email: string, update: boolean }) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.post(`add_update_user`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const deleteUsersData = async (body: any) => {
    const destinationObject = { ...body, client_env: localStorage.getItem("clientName") };
    try {
        const res: any = await http.post(`user_active_deactive`, destinationObject)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

interface sheet_date {
    start_date: string,
    end_date: string,
    users_list: string[]
    user_name: string | null,
    client_env: string | null,
}
export const getBase64OfSheet = async (dates: sheet_date) => {
    try {
        const res = await http.post(`get_conversation_history`, dates)
        return { result: res?.data }
    } catch (error: unknown) {
        const message = error instanceof Error ? error.message : "Unknown error";
        return {
            error: message
        }
    }
}
